export enum TokensCasino {
  INDEX = '/token-rules/casino',
  ARCHIVE = '/token-rules/casino/archive',
  CREATE = '/token-rules/casino/create',
  EDIT = '/token-rules/casino/edit',
}
